import styled, { css } from 'styled-components'
import {
  FormControl as LegosFormControl,
  ModalBody as LegosModalBody
} from '@rodeo-dev/legos'

export const CopyProject = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.palette.grey[200]};
    padding: ${theme.typography.pxToRem(14)} ${theme.typography.pxToRem(8)};
    border-radius: ${theme.typography.pxToRem(2)};
    flex-grow: 1;
  `}
`
export const FormControl = styled(LegosFormControl)`
  margin-top: ${({ theme }) => theme.typography.pxToRem(10)};
`
export const FromItem = styled.div`
  margin-top: ${({ theme, noMarginTop }) =>
    theme.typography.pxToRem(!noMarginTop && 10)};
  margin-right: ${({ theme }) => theme.typography.pxToRem(30)};
`

export const FromItemWithTooltip = styled.div`
  margin-top: ${({ theme }) => theme.typography.pxToRem(10)};
  display: flex;
`

export const Tags = styled.div`
  flex-grow: 1;
  padding: ${({ theme }) => theme.typography.pxToRem(2)};
`
export const Tooltip = styled.div`
  padding-top: ${({ theme }) => theme.typography.pxToRem(17)};
  padding-left: ${({ theme }) => theme.typography.pxToRem(10)};
`
export const ModalBody = styled(LegosModalBody)`
  padding-left: ${({ theme }) => theme.typography.pxToRem(50)};
`
